var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "flex",
    {
      staticClass: "type-list",
      attrs: { justify: "between", align: "center" }
    },
    _vm._l(_vm.typeList, function(item, index) {
      return _c(
        "flex",
        {
          key: index,
          staticClass: "type-item",
          attrs: { direction: "column", justify: "center", align: "center" },
          on: {
            click: function($event) {
              return _vm.selectType(item)
            }
          }
        },
        [
          _c("i", {
            staticClass: "type-icon",
            class: "iconfont icon-" + item.icon
          }),
          _vm._v(" "),
          _c("span", { staticClass: "type-name" }, [_vm._v(_vm._s(item.name))])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }